import Vue from 'vue'

export default {
  // GET enrolled authenticators (needs read:authenticators scope)
  getAuthenticators: function (mfaAccessToken) {
    let apiDetailPath = '/mfa/authenticators'
    return Vue.http.get(Vue.env.authApiPath + apiDetailPath, {
      headers: { 'Authorization': 'Bearer ' + mfaAccessToken }
    })
  },
  // Associate a new TOTP authenticator (needs enroll scope)
  associateOtp: function (mfaAccessToken) {
    let apiDetailPath = '/mfa/associate'
    let data = { authenticator_types: ['otp'] }
    return Vue.http.post(Vue.env.authApiPath + apiDetailPath, data, {
      headers: { 'Authorization': 'Bearer ' + mfaAccessToken, 'Content-Type': 'application/json' }
    })
  },
  // Confirm the just-associated TOTP by exchanging an OTP at the token endpoint.
  // NOTE: passes the MFA access token as `mfa_token`. Verified against the dev
  // tenant during manual verification; if Auth0 rejects it, adjust here only.
  confirmOtp: function (mfaToken, otp) {
    let apiDetailPath = '/oauth/token'
    let data = {
      grant_type: 'http://auth0.com/oauth/grant-type/mfa-otp',
      client_id: Vue.env.authClientID,
      mfa_token: mfaToken,
      otp: otp
    }
    return Vue.http.post(Vue.env.authApiPath + apiDetailPath, data, {
      headers: { 'Content-Type': 'application/json' }
    })
  },
  // Remove an authenticator (needs remove:authenticators scope)
  deleteAuthenticator: function (mfaAccessToken, authenticatorId) {
    let apiDetailPath = '/mfa/authenticators/' + authenticatorId
    return Vue.http.delete(Vue.env.authApiPath + apiDetailPath, {
      headers: { 'Authorization': 'Bearer ' + mfaAccessToken }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/mfa.js